var EHDI = EHDI || Object.create(null);

EHDI.popup = EHDI.popup || Object.create(null);

EHDI.popup.ConfirmPopUp = function() {
    EHDI.aka.Container.call(this);

    var _overlay, 
        _container,
        _quitLabel,
        _noButton,
        _yesButton; 
    
    this.popUpWillAppear = function() {
        _overlay = new EHDI.aka.Sprite(EHDI.displays.TextureRectangle(0x000000, EHDI.screen.stageWidth, EHDI.screen.stageHeight));
        _overlay.anchor.set(0.5, 0.5);
        _overlay.alpha = 0;
        
        this.addChild(_overlay);
        _overlay.interactive = true;
        
        _container = new EHDI.aka.Sprite( EHDI.Assets.images["WB_con_pause"] );
        _container.anchor.set(0.5, 0.5);
        _container.position.y = -EHDI.screen.stageHeight * 0.02;
        this.addChild(_container);
        
        _quitLabel = new EHDI.aka.PixiText( EHDI.localization.strings["confirm"].content, {
            fontFamily: "nuevastd-bold", 
            fontSize: EHDI.localization.strings["confirm"].size, 
            align: 'center',
            wordWrap: true,
            wordWrapWidth: _container.width * 0.8,
            fill: '#592E0E'
        });
        _quitLabel.anchor.set(0.5, 0.5);
        _quitLabel.position.set(0, -_container.height * 0.21);
        _container.addChild(_quitLabel);
    }
    
    this.popUpDidAppear = function() {
        _overlay.alpha = 0.5;
        _noButton = new EHDI.displays.Button(EHDI.Assets.images["btn_no"], null, null, null, 0.8);
        _noButton.position.set(-_container.width * 0.1, _container.height * 0.15);
        _container.addChild(_noButton);
        _noButton.setOnClickFunction(onNoButtonHit);
        
        _yesButton = new EHDI.displays.Button(EHDI.Assets.images["btn_yes"], null, null, null, 0.8);
        _yesButton.position.set(_container.width * 0.1, _container.height * 0.15);
        _container.addChild(_yesButton);
        _yesButton.setOnClickFunction(onYesButtonHit);
    }
    
    var onNoButtonHit = function() {
        EHDI.GAME.soundManager.playSFX("button_01");
        EHDI.GAME.sceneManager.popPopUp(null, true);
    }
    
    var onYesButtonHit = function() {
        EHDI.GAME.soundManager.playSFX("button_01");
        EHDI.GAME.soundManager.stopAllSFX();
        EHDI.GAME.sceneManager.popAllPopUps(true);
        EHDI.GAME.soundManager.resumeBGM();
        EHDI.GAME.sceneManager.changeScene(new EHDI.scene.TitleScene(), true);
    }
    
}

EHDI.popup.ConfirmPopUp.prototype = Object.create(EHDI.aka.Container.prototype);